import { LogicError } from '@belimo-retrofit-portal/logic';
import React from 'react';
import RequireContext = __WebpackModuleApi.RequireContext;

type SvgProps = React.SVGAttributes<SVGSVGElement>;

type Props = {
  readonly file: string;
  readonly width: number;
  readonly height: number;
};

export const SchemaFile = React.memo(({ file, width, height }: Props) => {
  const Svg = SCHEMA_FILES.get(file);
  if (!Svg) {
    throw new LogicError(
      `Schema file "${file}" could not be found`,
      { valid: [...SCHEMA_FILES.values()] },
    );
  }

  return (
    <Svg
      width={width}
      height={height}
      data-file={file}
    />
  );
});

function mapFiles(context: RequireContext): ReadonlyMap<string, React.ComponentType<SvgProps>> {
  const result = new Map<string, React.ComponentType<SvgProps>>();

  context.keys().forEach((key) => {
    const id = key
      .replace(/^\.\//, '')
      .replace(/\.svg$/, '');

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
    const component = context(key).default;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    result.set(id, component);
  });

  return result;
}

const SCHEMA_FILES = mapFiles(require.context('static/images/schemas/', true, /\.svg$/));
